import { install } from './install'

class VueComponents {
  constructor(preset = {}) {
    this.framework = {};
    this.installed = [];
    this.preset = preset;
  }

  init(root, ssrContext) {
    this.installed.forEach(property => {
      const service = this.framework[property];
      service.framework = this.framework;

      service.init(root, ssrContext);
    })

    this.framework.rtl = Boolean(this.preset.rtl);
  }

  use(Service) {
    const property = Service.property;

    if (this.installed.includes(property)) {
      return;
    }

    this.framework[property] = new Service(this.preset[property]);
    this.installed.push(property);
  }
}

VueComponents.install = install;
VueComponents.installed = false;

export default VueComponents;
